import { Badge, Box, Group, Text } from '@mantine/core';
import type { ReactElement } from 'react';
import { SurfaceCard } from '@/design/SurfaceCard';
import type { UseCaseCard, UseCaseExpansion } from './InsightsTypes';

interface InsightsUseCasesSectionProps {
    useCases: UseCaseExpansion;
}

function ExpansionCard({ card }: { card: UseCaseCard }): ReactElement {
    const tokens = { solid: 'var(--bm-color-brand-accent)', soft: 'var(--bm-color-brand-soft)', text: 'var(--bm-color-brand-accent)', border: 'var(--bm-color-brand-border)' };
    return (
        <SurfaceCard $padding="md" style={{ minWidth: 'min(320px, 85vw)', scrollSnapAlign: 'start' }}>
            <Text fw={700} size="sm">
                {card.title}
            </Text>
            <Text size="sm" c="dimmed" mt={6} style={{ lineHeight: 1.55, flex: 1 }}>
                {card.description}
            </Text>
            <Group justify="flex-start" align="center" mt="md">
                <Badge variant="light" style={{ background: tokens.soft, color: tokens.text, border: `1px solid ${tokens.border}` }}>
                    {card.suggestedModel}
                </Badge>
            </Group>
            <Text size="xs" fw={700} mt={6} style={{ color: tokens.text }}>
                ~{card.estMinutesSavedPerWeek} min saved / week
            </Text>
        </SurfaceCard>
    );
}

/** Use Case Expansion — where peers with the same title get value that the user doesn't yet. */
export default function InsightsUseCasesSection({ useCases }: InsightsUseCasesSectionProps): ReactElement {
    return (
        <Box style={{ display: 'flex', gap: 16, overflowX: 'auto', scrollSnapType: 'x mandatory', paddingBottom: 8 }}>
            {useCases.cards.map((card) => (
                <ExpansionCard key={card.id} card={card} />
            ))}
        </Box>
    );
}
